import React from 'react';
import { View, StyleSheet, ScrollView } from "react-native";
import _ from 'lodash'
import ButtonGroup from 'theme/ButtonGroup'
import Button from "theme/Button";
import Text from "theme/Text";
import { colorList } from "utils/colors";
import { ThemedBlockStyles, ThemedValues } from "styles/themed";
import HelperString from 'utils/helper-string'
import ThemedBadge from 'components/atoms/ThemedBadge'
import isEqual from 'react-fast-compare'
import { themedButtonBarStyle } from 'styles/components/atoms/ThemedButtonBar'

const ThemedButtonBar = ({ buttons = [], selected, onPress, style = {}, onLayout }) => {

	const viewStyle = [
		ThemedBlockStyles.container,
		themedButtonBarStyle.view,
		style
	]
	
	const buttonActiveStyle = [
		themedButtonBarStyle.button,
		styles.buttonActiveStyleBackgroundColorPrimary
	]
	
	const onPressButton = ( value ) => {
		if( _.isFunction( onPress ) ) {
			onPress( value );
		}
	}
	
	if( selected === null ) {
		selected = _.get( buttons, [ 0, 'key' ], null );
	}
	
	return (
		<View
			style={ viewStyle }>

			<ScrollView
				contentContainerStyle={ styles.scrollView }
				showsHorizontalScrollIndicator={ false }
				horizontal={ true }>

				<ButtonGroup
					onLayout={ onLayout }
					size={"small"}
					appearance={"outline"}
					style={ themedButtonBarStyle.buttonGroup }>

					{ _.map( buttons, button => {
						const { key, text, badge, testID } = button;
						const isActive = (key === selected);
						
						return (
							<Button
								key={ HelperString.hash( 'button', button.key ) }
								onPress={ onPressButton.bind( this, key ) }
								appearance='inverse'
								size='small'
								style={[ styles.button, isActive ? styles.buttonActive : {} ]}
								textStyle={ isActive ? styles.buttonActiveText : undefined }
								accessoryRight={ badge !== undefined && (
									<ThemedBadge
										containerStyle={ themedButtonBarStyle.badge }
										value={ _.toString( badge ) }
									/>
								)}>

								{ text }
							</Button>
						)
					})}
				</ButtonGroup>
			</ScrollView>
		</View>
	)
}

const styles = StyleSheet.create({
	buttonActiveStyleBackgroundColorPrimary: {
		backgroundColor: colorList.PRIMARY.primary,
	},
	scrollView: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
	},
	button: {
		borderRadius: 0,
		margin: 0,
	},
	buttonActive: {
		backgroundColor: colorList.PRIMARY.primary,
		borderRadius: ThemedValues.borderRadius,
		color: colorList.WHITE.primary,
	},
	buttonActiveText: {
		color: colorList.WHITE.primary,
	},
})

export default React.memo( ThemedButtonBar, isEqual );
